import type { AiComponentDto } from '@terra/shared-contracts-ai-applications';
import {
  BotIcon,
  PackageIcon,
  Brain01Icon,
  Database01Icon,
  File01Icon,
  GitBranchIcon,
  Layers01Icon,
  MemoryStickIcon,
  Message01Icon,
  HierarchyIcon,
  SecurityCheckIcon,
  Wrench01Icon,
  type TerraIcon,
} from '@terra/ui-icons';

export const AI_COMPONENT_TYPE_ICON_COLORS: Record<
  AiComponentDto['type'],
  {
    bg: string;
    border: string;
    color: string;
  }
> = {
  AGENT: {
    bg: 'bg.info.subtle',
    border: 'border.info.muted',
    color: 'fg.info',
  },
  SUB_AGENT: {
    bg: 'bg.info.subtle',
    border: 'border.info.muted',
    color: 'fg.info',
  },
  TOOL: {
    bg: 'bg.entity.assets',
    border: 'border.entity.asset',
    color: 'fg.default',
  },
  MCP_SERVER: {
    bg: 'bg.success.subtle',
    border: 'border.success.muted',
    color: 'fg.success',
  },
  MCP_TOOL: {
    bg: 'bg.success.subtle',
    border: 'border.success.muted',
    color: 'fg.success',
  },
  MCP_PROMPT: {
    bg: 'bg.info.subtle',
    border: 'border.info.muted',
    color: 'fg.info',
  },
  MCP_RESOURCE: {
    bg: 'bg.warning.subtle',
    border: 'border.warning.muted',
    color: 'fg.warning',
  },
  MCP_PROTOCOL: {
    bg: 'bg.purple.subtle',
    border: 'border.purple.muted',
    color: 'fg.purple',
  },
  RAG: {
    bg: 'bg.warning.subtle',
    border: 'border.warning.muted',
    color: 'fg.warning',
  },
  MODEL: {
    bg: 'bg.purple.subtle',
    border: 'border.purple.muted',
    color: 'fg.purple',
  },
  MEMORY: {
    bg: 'bg.neutral.subtle',
    border: 'border.neutral.muted',
    color: 'fg.muted',
  },
  GUARDRAIL: {
    bg: 'bg.danger.subtle',
    border: 'border.danger.muted',
    color: 'fg.danger',
  },
  INTEGRATION: {
    bg: 'bg.neutral.subtle',
    border: 'border.neutral.muted',
    color: 'fg.muted',
  },
};
export function getAiComponentTypeIcon(
  type: AiComponentDto['type'],
): TerraIcon {
  if (type === 'AGENT' || type === 'SUB_AGENT') return BotIcon;
  if (type === 'TOOL' || type === 'MCP_TOOL') return Wrench01Icon;
  if (type === 'MCP_PROMPT') return Message01Icon;
  if (type === 'MCP_RESOURCE') return PackageIcon;
  if (type === 'MCP_PROTOCOL') return Layers01Icon;
  if (type === 'MCP_SERVER') return HierarchyIcon;
  if (type === 'RAG') return Database01Icon;
  if (type === 'MODEL') return Brain01Icon;
  if (type === 'MEMORY') return MemoryStickIcon;
  if (type === 'GUARDRAIL') return SecurityCheckIcon;

  return GitBranchIcon;
}

export function getAiComponentGraphTypeIcon(
  type: AiComponentDto['type'],
): TerraIcon {
  if (type === 'MCP_RESOURCE') return File01Icon;

  return getAiComponentTypeIcon(type);
}
